export default function (timeZone) {

  return {
    default: {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
      timeZone,
    },

    defaultWithWeekday: {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
      weekday: 'short',
      timeZone,
    },

    full: {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      timeZone,
    },

    time: {
      hour: 'numeric',
      minute: 'numeric',
      hour12: false,
      timeZone,
    },
  }

}